import React, { useEffect, useState } from "react";
import { BodyView, ButtonView, InputView, HeaderTitleView } from "../factory/ViewUtil";
import { NavBar } from "antd-mobile";
import { ToastClear, ToastContent, ToastLoading } from "../factory/FactoryUtil";
import { H5Login, RegisterUser } from "../../NetworkFactory";

const CodeViewController = ({gohome, navpush, data}) => {
    const {id, email,  password} = data
    const [code, setCode] = useState('')

    const showError = () => {
        ToastContent(' Network or Unknown error')
    }
    
    const goLogin = () => {
        H5Login(email, password).then(code => {
            if(code === 200) {
                ToastContent('Login Success')
            } else {
                ToastContent('Abnormal')
            }
            gohome()
        })
    }

    const done = () => {
        if(code.length < 6 || code.length > 10) {
            ToastContent('Invalid verification code')
            return
        }
        ToastLoading('Registering...')
        RegisterUser({
            id : id,
            email : email,
            password : password,
            code : code
        }).then(response => {
            ToastClear()
            const {status} = response.data || {}
            if(status === -1) {
                ToastContent('Verification code error')
            }
            else if(status === -2) {
                ToastContent('Verification code expired')
            }
            else if(status === 200) {
                goLogin()
            }
            else {
                showError()
            }
        }).catch(() => {
            ToastClear()
            showError()
        })
    }

    useEffect(()=> {
        if(!id || !email || !password) {
            ToastContent('Error')
            gohome()
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    
    return(
        <>
            <NavBar onBack={()=> {navpush('/login', true)}}></NavBar>
            <BodyView>
                <HeaderTitleView>We will send the email <br/>verification code to your email</HeaderTitleView>
                <InputView value={code} onChange={val => {setCode(val)}} title='Email Code' type='number' clearable/>
                <ButtonView onClick={done} style={{ width : '100%', marginTop: '20px'}}>Done</ButtonView>
            </BodyView>
        </>
    )
}

export default React.memo(CodeViewController)